import { useGameStore } from '../store';
import type { Leverage } from '../types';

const CHIPS: Array<{ lev: Leverage; name: string; mult: string; cls?: string }> = [
  { lev: 1,   name: '자기돈', mult: '×1' },
  { lev: 5,   name: '차용',   mult: '×5' },
  { lev: 10,  name: '큰빚',   mult: '×10',  cls: 'warn' },
  { lev: 50,  name: '고리대금', mult: '×50', cls: 'danger' },
  { lev: 100, name: '사채',   mult: '×100', cls: 'danger' },
];

export default function LeverageRow() {
  const lev     = useGameStore((s) => s.lev);
  const hasPos  = useGameStore((s) => s.position !== null);
  const selectLev = useGameStore((s) => s.selectLev);

  return (
    <div id="leverage-row">
      {CHIPS.map((c) => {
        const cls = ['lev-chip'];
        if (c.cls) cls.push(c.cls);
        if (lev === c.lev) cls.push('active');
        if (hasPos) cls.push('disabled');
        return (
          <div key={c.lev} className={cls.join(' ')} onClick={() => selectLev(c.lev)}>
            <div className="lev-name">{c.name}</div>
            <div className="lev-mult">{c.mult}</div>
          </div>
        );
      })}
    </div>
  );
}
